import React, { useState } from 'react';

import {
  GoogleMap,
  Marker,
  InfoWindow,
  MarkerClusterer
} from '@react-google-maps/api';
import GoogleMapContainer from '../../map/GoogleMapContainer';
import {
  COMMERCIAL_MAP_CLUSTER_STYLE,
  getMarkerCenter
} from '../../../utils/mapUtils';

import Map_Marker from '../../../static/assets/commercial/images/icon-map-marker-business.svg';
import Golf_Cart_Marker from '../../../static/assets/commercial/images/icon-map-marker-golf-cart.svg';
import Golf_Cart_Marker_Offline from '../../../static/assets/commercial/images/icon-map-marker-golf-cart-offline.svg';

import './CommercialMap.css';

function CommercialMap({ zoom, center, places, loadingElement }) {
  const [markerClicked, setMarkerClicked] = useState(false);

  const onMarkerClick = place => {
    setMarkerClicked(place);
  };

  const { lat, lng, id } = markerClicked;

  return (
    <GoogleMapContainer loadingElement={loadingElement}>
      <GoogleMap
        center={center}
        zoom={zoom}
        options={{
          streetViewControl: false,
          scaleControl: false,
          mapTypeControl: false,
          panControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUI: true
        }}
      >
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          gridSize={60}
          maxZoom={20}
          styles={COMMERCIAL_MAP_CLUSTER_STYLE}
        >
          {clusterer => (
            <>
              {places.map((place, index) => (
                <Marker
                  key={index}
                  clusterer={clusterer}
                  position={getMarkerCenter(place)}
                  title={JSON.stringify(index)}
                  onClick={() => onMarkerClick(place)}
                  icon={{
                    url:
                      place.deviceType === 'location tracker' && !place.offline
                        ? Golf_Cart_Marker
                        : place.offline
                        ? Golf_Cart_Marker_Offline
                        : Map_Marker,
                    scaledSize: new window.google.maps.Size(33, 43)
                  }}
                />
              ))}
            </>
          )}
        </MarkerClusterer>

        {markerClicked && (
          <InfoWindow
            onCloseClick={() => setMarkerClicked(false)}
            anchor={id}
            position={{
              lat: lat,
              lng: lng
            }}
          >
            <>{JSON.stringify(markerClicked)}</>
          </InfoWindow>
        )}
      </GoogleMap>
    </GoogleMapContainer>
  );
}

export default CommercialMap;
